/* eslint-disable react/prop-types */

/**
 * @author Shalini Jha
 * @name ProgressBar
 * @desc This component renders a linear progress bar
 */
import React from 'react';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import PropTypes from 'prop-types';
import { ProgressBarStyle } from './overwriteStyles';
const { withStyles } = MaterialUiCore;
const { LinearProgress } = MaterialUiCore;
export const styles = () => ProgressBarStyle;

const ProgressBar = ({ value, classes }) => (
    <div className={classes.root}>
        <LinearProgress value={value} variant="determinate" />
    </div>
);

ProgressBar.propTypes = {
    value: PropTypes.number.isRequired,
    classes: PropTypes.shape({}).isRequired,
};
export default withStyles(styles)(ProgressBar);
